import { render } from "./BloemenView.vue?vue&type=template&id=68dc744c"
import script from "./BloemenView.vue?vue&type=script&lang=js"
export * from "./BloemenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__